import $ from 'jquery';
import { hideButtonLoader, showButtonLoader, toggleButtonLoader } from '../../../utils/button-loader';
import DateInput from '../../../components/date-input';
import { fieldErrorsToValidatorErrors } from '../../../utils/field-errors';
import { AgeVerificationNameMismatchModal } from './age-verification-name-mismatch-modal';
import { DokobitError } from '../../../types/dokobit-errors';
const ELEMENT_SELECTOR = '.js__age-verification-age-mismatch-modal';
export class AgeVerificationAgeMismatchModal {
    static $element;
    static $form;
    static $birthdayInput;
    static $submitButton;
    static $cancelAction;
    static $alert;
    static init() {
        this.$element = $(ELEMENT_SELECTOR);
        this.$form = $(`${ELEMENT_SELECTOR}-form`);
        this.$birthdayInput = $(`${ELEMENT_SELECTOR}-birhday-input`);
        this.$submitButton = AgeVerificationAgeMismatchModal.$form.find(':submit');
        this.$cancelAction = $(`${ELEMENT_SELECTOR}-cancel`);
        this.$alert = $(`${ELEMENT_SELECTOR}-alert`);
        setTimeout(() => {
            this.bindEvents();
            DateInput.init();
        }, 100);
    }
    static show() {
        this.$element.modal({
            backdrop: 'static',
            keyboard: false,
        });
    }
    static bindEvents() {
        this.getFormValidator().settings.submitHandler = () => {
            this.submitForm();
        };
        this.$cancelAction.on('click', event => {
            this.handleCancelAction(event);
        });
    }
    static getFormValidator() {
        return this.$form.data('validator');
    }
    static submitForm() {
        if (this.$submitButton.prop('disabled')) {
            return;
        }
        showButtonLoader(this.$submitButton);
        this.$cancelAction.addClass('disabled');
        this.$alert.hide();
        $.ajax({
            type: this.$form.attr('method'),
            url: this.$form.attr('action'),
            data: this.$form.serialize(),
        }).then(data => {
            window.location.assign(data.redirect_url);
        }, data => {
            const response = data.responseJSON;
            if (response.redirect_url) {
                window.location.assign(response.redirect_url);
                return;
            }
            hideButtonLoader(this.$submitButton);
            this.$cancelAction.removeClass('disabled');
            if (response.error === DokobitError.NameMismatch) {
                this.close();
                AgeVerificationNameMismatchModal.updateDescription(response.additional_data.entered_data, response.additional_data.verified_data);
                AgeVerificationNameMismatchModal.show();
                return;
            }
            let fieldErrors = response.error === DokobitError.AgeMismatch
                ? [
                    {
                        fieldId: this.$birthdayInput.prop('id'),
                        error: this.$birthdayInput.data('age-mismatch-error'),
                    },
                ]
                : response.errors;
            if (fieldErrors) {
                this.getFormValidator().showErrors(fieldErrorsToValidatorErrors(this.$form, fieldErrors));
            }
            else {
                this.$alert.show();
            }
        });
    }
    static handleCancelAction(event) {
        event.preventDefault();
        const $target = $(event.currentTarget);
        toggleButtonLoader($target, true);
        this.$submitButton.addClass('disabled');
        this.$alert.hide();
        $.post($target.attr('href')).then(() => { }, data => {
            const response = data.responseJSON;
            if (response.error === DokobitError.NameMismatchCancel || response.error === DokobitError.Lockdown) {
                window.location.assign(response.redirect_url);
                return;
            }
            toggleButtonLoader($target, false);
            this.$submitButton.removeClass('disabled');
            this.$alert.show();
        });
    }
    static close() {
        this.$element.modal('hide');
    }
}
